import { FC } from 'react';
import { SEVERITY, SeverityLevel } from '@silverfort/sf-components';

interface SeverityColumnProps {
    severity: SEVERITY;
    isBlurred: boolean
}

const SeverityColumn: FC<SeverityColumnProps> = ({ severity, isBlurred }) => {
    const opacityClassName = isBlurred ? 'opacity-20' : '';

    return (
        <div className={`flex justify-center items-center ${opacityClassName}`}>
            <SeverityLevel severity={severity} />
        </div>
    );
};

export default SeverityColumn;
